export const MembersNavbar = {
  flow: 'x',
  align: 'center',
  ActiveCanvasUsers: {},
  Invite: {
    // Outlined-button-on-top-of-a-themed-fill (design-direction.md §8 ban
    // list) — `theme: 'secondary'` below already fills and separates the
    // button; the stroke was redundant chrome.
    extends: ['IconButton', 'DropdownParentFocus'],
    margin: '- - - -Z',
    round: 'radiusPill',
    Icon: {
      fontSize: 'Z'
    },
    padding: 'Y+U',
    title: (el) => el.call('polyglot', 'members.navbar.invite'),
    icon: 'plus',
    theme: 'secondary',
    Dropdown: {
      left: '-F1',
      onClick: () => {},
      InviteDropdown: {}
    }
  }
}
